import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/asset-dashboard/page.tsx");
